import * as Yup from "yup";

const dateFormat = /^\d{2}\.\d{2}\.\d{4}$/;
const passportNumberFormat = /^\d{4}\s\d{6}$/;
const divisionCodeFormat = /^\d{3}-\d{3}$/;
const phoneFormat = /^\+?[0-9\s\-()]{7,20}$/;
const innFormat = /^\d{12}$/;
const bankDetailsFormat = /^\d{20}$/;
const bankBikFormat = /^\d{9}$/;

export const selfEmployedRegistrationValidationSchema = Yup.object().shape({
  fullName: Yup.string().min(1, "Введите ФИО").required("Обязательное поле"),
  birthDate: Yup.string()
    .matches(dateFormat, "Формат: DD.MM.YYYY")
    .required("Обязательное поле"),
  passportNumber: Yup.string()
    .matches(passportNumberFormat, "Формат: 1234 567890")
    .required("Обязательное поле"),
  passportIssuedBy: Yup.string()
    .min(1, "Введите кем и когда выдан паспорт")
    .required("Обязательное поле"),
  passportDivisionCode: Yup.string()
    .matches(divisionCodeFormat, "Формат: 123-456")
    .required("Обязательное поле"),
  registrationAddress: Yup.string()
    .min(1, "Введите адрес регистрации")
    .required("Обязательное поле"),
  phone: Yup.string()
    .matches(phoneFormat, "Некорректный номер телефона")
    .required("Обязательное поле"),
  email: Yup.string()
    .email("Введите корректный email")
    .max(320, "Слишком длинный email")
    .required("Обязательное поле"),
  inn: Yup.string()
    .matches(innFormat, "ИНН — 12 цифр")
    .required("Обязательное поле"),
  bankDetails: Yup.string()
    .matches(bankDetailsFormat, "Номер счёта — 20 цифр (начинается с 40817)")
    .required("Обязательное поле"),
  bankBik: Yup.string()
    .matches(bankBikFormat, "БИК — 9 цифр")
    .required("Обязательное поле"),
  passportFirstPage: Yup.mixed().required("Загрузите первую страницу паспорта"),
  passportAddressPage: Yup.mixed().required(
    "Загрузите страницу паспорта с пропиской",
  ),
  parentsAgreeFile: Yup.mixed().nullable(),
  passportFirstPageLink: Yup.string(),
  passportRegistrationPageLink: Yup.string(),
  parentalConsentLink: Yup.string(),
  consent: Yup.boolean()
    .oneOf([true], "Необходимо согласие на обработку персональных данных")
    .required("Необходимо согласие на обработку персональных данных"),
});
